import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileInvoiceDollar,
  faDownload,
  faExternalLinkAlt,
  faXmark,
  faPaperclip,
} from '@fortawesome/free-solid-svg-icons';
import '../styles/modal-shared.css';
import { apiUrl } from '../utils/documents';

function InvoicePdfModal({ show, onHide, pdfData, invoiceNumber }) {
  if (!pdfData) return null;

  const { dataUrl, docs } = pdfData;

  const handleDownload = () => {
    const link = Object.assign(document.createElement('a'), {
      href: dataUrl,
      download: `Invoice_${invoiceNumber}.pdf`,
    });
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // A backend route, opened as a navigation: it authenticates by cookie and
  // checks the document belongs to this customer's invoice. It has to be made
  // absolute — a bare "/api/..." would land on the portal's own server. (This
  // used to open the blob's public storage URL.)
  const getDocumentUrl = (doc) =>
    apiUrl(doc.blobUrl || `/api/invoices/documents/${encodeURIComponent(doc.fileName)}`);

  const openDocument = (doc) => {
    const url = getDocumentUrl(doc);
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  };

  const openInNewTab = () => {
    if (dataUrl) window.open(dataUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      dialogClassName="detail-modal doc-viewer-modal"
    >
      {/* ── HEADER ── */}
      <Modal.Header closeButton>
        <div className="modal-title-row">
          <div className="modal-header-icon">
            <FontAwesomeIcon icon={faFileInvoiceDollar} />
          </div>
          <div className="modal-header-text">
            <h5>Invoice {invoiceNumber}</h5>
            <p className="modal-subtitle">PDF Preview</p>
          </div>
        </div>
      </Modal.Header>

      {/* ── BODY — full-height viewer ── */}
      <Modal.Body className="doc-viewer-body" style={{ padding: 0 }}>
        {/* macOS-style chrome bar */}
        <div className="doc-viewer-chrome">
          <div className="doc-viewer-chrome-dot" style={{ background: '#ef4444' }} />
          <div className="doc-viewer-chrome-dot" style={{ background: '#f59e0b' }} />
          <div className="doc-viewer-chrome-dot" style={{ background: '#10b981' }} />
          <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.4)', marginLeft: 8 }}>
            Invoice {invoiceNumber}
          </span>
        </div>

        <div className="doc-viewer-frame-wrap">
          <iframe
            src={dataUrl}
            title={`Invoice ${invoiceNumber}`}
            className="doc-viewer-frame"
          />
        </div>
      </Modal.Body>

      {/* ── FOOTER ── */}
      <Modal.Footer style={{ flexDirection: 'column', alignItems: 'stretch', gap: 0, padding: 0 }}>
        {/* Attachments */}
        {docs && docs.length > 0 && (
          <div style={{ padding: '10px 16px', borderBottom: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: '0.68rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: '#94a3b8', marginBottom: 6 }}>
              <FontAwesomeIcon icon={faPaperclip} style={{ marginRight: 5 }} />
              Attachments
            </div>
            <ul className="detail-doc-list">
              {docs.map((doc, index) => (
                <li
                  key={index}
                  className="detail-doc-item"
                  onClick={() => openDocument(doc)}
                  style={{ padding: '7px 4px' }}
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="doc-icon" />
                  {doc.descr || doc.Description || doc.fileName}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Action buttons */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 16px' }}>
          <button
            className="detail-btn detail-btn--ghost"
            onClick={openInNewTab}
            style={{ marginRight: 'auto' }}
          >
            <FontAwesomeIcon icon={faExternalLinkAlt} />
            Open in New Tab
          </button>
          <button className="detail-btn detail-btn--secondary" onClick={onHide}>
            <FontAwesomeIcon icon={faXmark} />
            Close
          </button>
          <button className="detail-btn detail-btn--primary" onClick={handleDownload}>
            <FontAwesomeIcon icon={faDownload} />
            Download PDF
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default InvoicePdfModal;
